import React, { useEffect, useState } from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import parse from "react-html-parser";
import "./SellHeroSection.css";

import IconSVG from "../../../../public/assets/images/sell/SellResCircleLogo";
import SellComercialSvg from "../../../../public/assets/images/sell/SellCommercialBg";
import SellResidentialSvg from "../../../../public/assets/images/sell/sellResidentialBg";
import HubzuContactUsComModal from "../Modal/HubzuContactUsComModal";
import HubzuContactUsBrokerModal from "../Modal/HubzuContactUsBrokerModal";
import { formatCmsTextToHtml } from "@/utils/textParser";

const SellHeroSection = ({ cmsData, type }) => {
  const heroData = cmsData?.[0]?.heroSection || {};
  const [dimensions, setDimensions] = useState(getDimensions());

  const [showContactUsCommercialModal, setShowContactUsCommercialModal] =
    useState(false);
  const [showContactUsBrokerModal, setShowContactUsBrokerModal] =
    useState(false);

  // Extract dimensions based on screen width
  function getDimensions() {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) {
      return {
        svgBgWidth: 1081,
        svgBgHeight: 676,
        iconWidth: 90,
        iconHeight: 90,
        iconX: 720,
        iconY: screenWidth <= 648 ? 310 : 294,
      };
    }
    if (screenWidth <= 1024) {
      return {
        svgBgWidth: 1081,
        svgBgHeight: 676,
        iconWidth: 123,
        iconHeight: 123,
        iconX: 820,
        iconY: 268,
      };
    }
    return {
      svgBgWidth: 1081,
      svgBgHeight: 876,
      iconWidth: 223,
      iconHeight: 223,
      iconX: 800,
      iconY: 360,
    };
  }

  useEffect(() => {
    const updateDimensions = () => setDimensions(getDimensions());

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const comModalData = cmsData[0]?.contactUsComModal;
  const brokerModalData = cmsData[0]?.contactUsBrokerModal;

  const handleNavigate = () => {
    window.location.href = cmsData[0]?.externalAppUrl || "";
  };

  const handleContactUsComModal = () => {
    setShowContactUsCommercialModal(!showContactUsCommercialModal);
  };

  const handleContactUsBrokerModal = () => {
    setShowContactUsBrokerModal(!showContactUsBrokerModal);
  };

  // Background rendering logic
  const renderBackground = () => {
    switch (type) {
      case "residential":
        return (
          <>
            <div className="hero-svg-bg">
              {/* <SellResidentialSvg {...dimensions} /> */}
              <IconSVG className="hubzu-res-logo" height={220} />
            </div>
            <div
              className="mobileBgImgRes"
              style={{ backgroundImage: `url(${heroData?.mobileBgImage})` }}
            />
            <IconSVG className="mobileIcon" />
          </>
        );
      case "broker":
        return (
          <>
            <div className="hero-svg-bg">
              <SellComercialSvg />
            </div>
            <div
              className="mobileBgImgBroker"
              style={{ backgroundImage: `url(${heroData?.mobileBgImage})` }}
            />
          </>
        );
      default:
        return (
          <div
            className="mobileBgImgCom"
            style={{ backgroundImage: `url(${heroData?.mobileBgImage})` }}
          />
        );
    }
  };

  // Check if heroData has required information to render
  if (!heroData?.title) {
    return null; // or display a loading spinner/placeholder if necessary
  }

  const formatPhoneText = (text) => {
    if (!text) return null;
    // Regular expression to match the phone number pattern
    const phonePattern = /Call \(\d{3}\) \d{3}-\d{4}/;
    const phoneMatch = text.match(phonePattern);

    if (phoneMatch) {
      const phoneText = phoneMatch[0];
      const remainingText = text.replace(phonePattern, "");

      return (
        <>
          <span style={{ fontWeight: 700 }}>{phoneText}</span>
          <span style={{ fontWeight: 500 }}>{remainingText}</span>
        </>
      );
    }

    return text;
  };

  return (
    <Container fluid className="sell-hero-section">
      {renderBackground()}

      <Row className="align-items-center sell-content-container">
        {/* Left Content Section */}
        {heroData && (
          <Col
            md={6}
            className={`text-left leftPartSection ${
              type === "broker" && "broker-class"
            } ${
              type === "commercial" && "commercial-class leftPartSectionPad"
            } ${
              type === "residential" && "residential-class leftPartSectionPad"
            } `}
          >
            <div className="leftPartSection1">
              <h1>{parse(formatCmsTextToHtml(heroData?.title))}</h1>
            </div>
            <div
              className={`leftPartSection2 ${
                type === "residential" && "residential-leftPartSection2"
              }`}
            >
              <h2>{parse(formatCmsTextToHtml(heroData?.description))}</h2>
            </div>
            {type === "residential" && (
              <div className="numberSupport residential-numberSupport">
                {parse(formatCmsTextToHtml(heroData?.contactDesc))}
              </div>
            )}
            {type === "commercial" && (
              <div className="numberSupport">
                {formatPhoneText(heroData?.contactDesc)}
              </div>
            )}
            <Button
              className="btn-primary cont-btn-home"
              onClick={
                type === "broker"
                  ? handleContactUsBrokerModal
                  : type === "residential"
                  ? handleNavigate
                  : handleContactUsComModal
              }
            >
              {type === "residential" ? "Register" : "Contact Us"}
            </Button>
            <div className="leftPartSection2SubDesc">
              {parse(formatCmsTextToHtml(heroData?.subDescription))}
            </div>
          </Col>
        )}

        {/* Right Video Section */}
        <Col
          md={6}
          className={
            type === "residential"
              ? "hero-media-container"
              : type === "broker"
              ? "hero-media-broker-container"
              : "hero-media-com-container"
          }
        >
          <video
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            className="hero-video"
            autoPlay
            muted
            playsInline
            src={heroData?.bgVideoUrl}
            alt="Marketing Video"
          />
        </Col>
      </Row>

      <HubzuContactUsComModal
        isModalOpen={showContactUsCommercialModal}
        handleModal={handleContactUsComModal}
        cmsData={comModalData}
      />
      <HubzuContactUsBrokerModal
        isModalOpen={showContactUsBrokerModal}
        handleModal={handleContactUsBrokerModal}
        cmsData={brokerModalData}
      />
    </Container>
  );
};

export default SellHeroSection;
